import { graphql } from "gatsby";
import { Page } from "../components/page";
import React, { useState } from "react";
import GraphQLErrorList from "../graphql/graphql-error-list";
import { LayoutContainer } from "../containers/layout";
import Container from "../components/global/container";
import PageHeadMeta from "../components/global/page-head-meta";
import { toPlainText } from "../lib/helpers";

export const query = graphql`
  query PageTemplateQuery($id: String!) {
    page: sanityPage(id: { eq: $id }) {
      _type
      id
      _id
      hideTitle
      mainImage {
        ...SanityImage
        alt
      }
      title
      slug {
        current
      }
      status
      _updatedAt
      _createdAt
      contentType
      hideNav
      pageWidth
      backgroundColor
      backgroundImage {
        ...SanityImageSimple
      }
      categories {
        _id
        title
        titlePublic
      }
      companies {
        _id
      }
      sections {
        ... on SanityPageComponent {
          _type
          name
          anchor
          header
          _rawSummary(resolveReferences: { maxDepth: 5 })
          layout
          background
          padding
          container
          mainImage {
            ...SanityImageSimple
          }
          image {
            ...SanityImage
            alt
            caption
            link
          }
          category
          effect
          cards
          types
          contentRefs {
            ... on SanityPlaybook {
              _id
              _type
              title
              slug {
                current
              }
              _rawExcerpt(resolveReferences: { maxDepth: 5 })
              authors {
                _key
                author {
                  ...SanityAuthor
                }
              }
            }
            ... on SanityQuotable {
              ...Quotable
            }
          }
          # columns
        }
        ... on SanityPageSectionSimple {
          _type
          _rawContent(resolveReferences: { maxDepth: 5 })
          anchor
          header
          _rawSummary(resolveReferences: { maxDepth: 5 })
          layout
          background
          padding
          container
          mainImage {
            ...SanityImageSimple
          }
          image {
            ...SanityImage
            alt
            caption
            link
          }
          tableOfContents
          rounded
          constrainImages
        }
        ... on SanityPageSectionColumns {
          _type
          content {
            header
            mainImage {
              ...SanityImageSimple
            }
            _rawContent(resolveReferences: { maxDepth: 5 })
            author {
              ...SanityAuthor
            }
            layout
            icon
            imageAlt
          }
          maxColumns
          anchor
          header
          _rawSummary(resolveReferences: { maxDepth: 5 })
          layout
          background
          padding
          style
          container
          image {
            ...SanityImage
          }
        }
        ... on SanityWebForm {
          _type
          anchor
          header
          _rawSummary(resolveReferences: { maxDepth: 5 })
          background
          padding
          container
          campaign
          campaignType
          lists
          sendgridListsOptional
          alertEmail
          buttonText
          formFieldOpenTextPlaceholder
          _rawSuccess(resolveReferences: { maxDepth: 5 })
        }
        ... on SanityWebFormHubspot {
          _type
          anchor
          header
          _rawSummary(resolveReferences: { maxDepth: 5 })
          background
          padding
          container
          layout
          formId
          buttonText
          redirectUrl
          formFieldsPresets {
            label
            value
          }
        }
        ... on SanityEmbedSection {
          _type
          embedId
          type
          header
          _rawSummary(resolveReferences: { maxDepth: 5 })
          padding
        }
        ... on SanityPageSectionSlides {
          _type
          anchor
          header
          _rawSummary(resolveReferences: { maxDepth: 5 })
          background
          padding
          layout
          effect
          container
          mainImage {
            ...SanityImageSimple
          }
          image {
            ...SanityImage
            alt
          }
          category
          contentRefs {
            ... on SanityPlaybook {
              _id
              _type
              title
              slug {
                current
              }
            }
            ... on SanityQuotable {
              ...Quotable
            }
          }
          content {
            _key
            header
            mainImage {
              ...SanityImageSimple
            }
            mainImageFade {
              ...SanityImageSimple
            }
            mainVideo {
              asset {
                url
                extension
              }
            }
            _rawContent(resolveReferences: { maxDepth: 5 })
            author {
              ...SanityAuthor
            }
            layout
            contentRefs {
              _id
              _type
              title
              slug {
                current
              }
            }
            link
            icon
          }
        }
        ... on SanityPageSectionList {
          _type
          anchor
          header
          _rawSummary(resolveReferences: { maxDepth: 5 })
          background
          padding
          container
          layout
          ctaPath
          cta
          list {
            ... on SanityStory {
              ...cardNodeStory
            }
            ... on SanityQuotable {
              ...Quotable
            }
            ... on SanityPost {
              ...cardNode
            }
            ... on SanityPlaybook {
              ...cardNodePlaybook
            }
            ... on SanityPage {
              ...cardNodePage
            }
          }
        }
        ... on SanityPageSectionCompare {
          _type
          _rawCrDescription(resolveReferences: { maxDepth: 5 })
          competitor
          _rawCompetitorDescription(resolveReferences: { maxDepth: 5 })
          anchor
          header
          _rawSummary(resolveReferences: { maxDepth: 5 })
          background
          padding
          container
          table {
            label
            url
            native
            compare
            isHeader
      #      _rawTooltip(resolveReferences: { maxDepth: 5 })
            icon
            featured
          }
        }
        ... on SanityPageSectionPricingPlans {
          _type
          anchor
          header
          _rawSummary(resolveReferences: { maxDepth: 5 })
          background
          padding
          container
          plans {
            _key
            planKey {
              current
            }
            title
            color
            price
            priceDetails
            _rawSummary(resolveReferences: { maxDepth: 5 })
            ctaLabel
            ctaHref
            ctaBgColor
            ctaClassName
            actionDetails
            integrations
            _rawIntegrationsSummary(resolveReferences: { maxDepth: 5 })
            details {
              _key
              title
              path
              _rawSummary(resolveReferences: { maxDepth: 5 })
            }
          }
        }
        ... on SanityPageSectionPricingComparison {
          _type
          anchor
          header
          _rawSummary(resolveReferences: { maxDepth: 5 })
          background
          padding
          container
          layout
          plans {
            _key
            planKey {
              current
            }
            title
          }
          comparison {
            _key
            isHeader
            title
            emoji
            summary
            summaryTooltip
            values {
              _key
              included
              message
              tooltip
              path
            }
          }
        }
        ... on SanityPageSectionAgent {
          _type
          anchor
          header
          _rawSummary(resolveReferences: { maxDepth: 5 })
          background
          padding
          container
          layout
          agentRef {
            _id
            _type
            title
            slug {
              current
            }
            copilot_id
            workflow_id
            role
            tasks
            _rawInterject(resolveReferences: { maxDepth: 5 })
            _rawAnswers(resolveReferences: { maxDepth: 5 })
            steps {
              goal
              _rawResponse(resolveReferences: { maxDepth: 5 })
              smarts
              achievement {
                cta
                url
                message
              }
            }
            questions {
              text
              _rawPrompt(resolveReferences: { maxDepth: 5 })
              _rawAnswer(resolveReferences: { maxDepth: 5 })
            }
            icon
          }
        }
        ... on SanityPageSectionComponentList {
          _type
          maxColumns
          anchor
          layout
          padding
          container
          background
          content {
            content {
              ... on SanityPageSectionSimple {
                _type
                _rawContent(resolveReferences: { maxDepth: 5 })
                header
                _rawSummary(resolveReferences: { maxDepth: 5 })
                layout
                padding
                container
                anchor
                background
                tableOfContents
                image {
                  ...SanityImage
                  alt
                  link
                }
              }
              ... on SanityWebFormHubspot {
                _type
                anchor
                header
                _rawSummary(resolveReferences: { maxDepth: 5 })
                background
                padding
                container
                layout
                formId
                buttonText
                redirectUrl
              }
              ... on SanityEmbedSection {
                _type
                embedId
                type
                header
                _rawSummary(resolveReferences: { maxDepth: 5 })
                padding
              }
              ... on SanityPageComponent {
                _type
                name
                anchor
                header
                _rawSummary(resolveReferences: { maxDepth: 5 })
                layout
                background
                padding
                container
                mainImage {
                  ...SanityImageSimple
                }
                image {
                  ...SanityImage
                  alt
                }
                cards
              }
              ... on SanityPageSectionColumns {
                _type
                content {
                  header
                  mainImage {
                    ...SanityImageSimple
                  }
                  _rawContent(resolveReferences: { maxDepth: 5 })
                  author {
                    ...SanityAuthor
                  }
                  layout
                  icon
                  imageAlt
                }
                maxColumns
                anchor
                header
                _rawSummary(resolveReferences: { maxDepth: 5 })
                layout
                background
                padding
                style
                container
              }
            }
          }
        }
      }
      _rawExcerpt(resolveReferences: { maxDepth: 5 })
      relatedPosts {
        ...cardNode
      }
      relatedPlaybooks {
        ...cardNodePlaybook
      }
    }
  }
`;

const PageTemplate = (props) => {
  const { data, errors, pageContext } = props;
  const page = data && data.page;
  const [browserTitle, setBrowserTitle] = useState(page.title);

  // @todo move the exception for uncommon landing to url generation not meta data
  // see: gatsyby-node.js
  const isHomepage = ["/", "new"].includes(page?.slug?.current);

  return (
    <LayoutContainer
      // @todo center the logo and fix spacing
      hideNav={page?.hideNav || pageContext?.hideNav}
      doc={page}
      isHomepage={isHomepage}
      location={props.location}
      pageContext={pageContext}
    >
      {errors && <PageHeadMeta title="GraphQL Error" />}
      {page && (
        <PageHeadMeta
          title={browserTitle}
          isTitleOverriden={isHomepage || browserTitle !== page.title}
          description={toPlainText(page?._rawExcerpt)}
          image={page?.mainImage}
          doc={page}
        />
      )}
      {errors && (
        <Container>
          <GraphQLErrorList errors={errors} />
        </Container>
      )}
      <Page {...page} isHomepage={isHomepage} setBrowserTitle={setBrowserTitle} pageContext={pageContext} />
    </LayoutContainer>
  );
};

export default PageTemplate;
